import _classCallCheck from '../../../../../node_modules/@babel/runtime/helpers/classCallCheck.es.js';
import _createClass from '../../../../../node_modules/@babel/runtime/helpers/createClass.es.js';
import _inherits from '../../../../../node_modules/@babel/runtime/helpers/inherits.es.js';
import _possibleConstructorReturn from '../../../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.es.js';
import _getPrototypeOf from '../../../../../node_modules/@babel/runtime/helpers/getPrototypeOf.es.js';
import { getScrollParent } from '@mgmresorts/wcl-utils';
import React from 'react';
import { DivWithIntersectionObserver } from '../../DivWithIntersectionObserver/DivWithIntersectionObserver.es.js';
import '../../Icons/icons/createIcon.es.js';
import '../../Icons/icons/AdultsOnlyIcon.es.js';
import '../../Icons/icons/AttractionsIcon.es.js';
import '../../Icons/icons/BackIcon.es.js';
import '../../Icons/icons/BarberIcon.es.js';
import '../../Icons/icons/BedIcon.es.js';
import '../../Icons/icons/BestRateGuaranteedIcon.es.js';
import '../../Icons/icons/CalendarIcon.es.js';
import '../../Icons/icons/CartIcon.es.js';
import '../../Icons/icons/ChairIcon.es.js';
import '../../Icons/icons/CheckIcon.es.js';
import '../../Icons/icons/CirqueIcon.es.js';
import '../../Icons/icons/CloseCircleFilledIcon.es.js';
import '../../Icons/icons/CloseIcon.es.js';
import '../../Icons/icons/ComedyIcon.es.js';
import '../../Icons/icons/ConcertsIcon.es.js';
import '../../Icons/icons/CouchIcon.es.js';
import '../../Icons/icons/CreditCardIcon.es.js';
import '../../Icons/icons/CulinaryIcon.es.js';
import '../../Icons/icons/DesertViewIcon.es.js';
import '../../Icons/icons/DrinkIcon.es.js';
import { DropdownArrowIcon } from '../../Icons/icons/DropdownArrowIcon.es.js';
import '../../Icons/icons/EnlargeIcon.es.js';
import '../../Icons/icons/FanIcon.es.js';
import '../../Icons/icons/FilterIcon.es.js';
import '../../Icons/icons/ForwardIcon.es.js';
import '../../Icons/icons/FreeCancellationIcon.es.js';
import '../../Icons/icons/GridDisabledIcon.es.js';
import '../../Icons/icons/GridEnabledIcon.es.js';
import '../../Icons/icons/GuestsIcon.es.js';
import '../../Icons/icons/HeartIcon.es.js';
import '../../Icons/icons/HidePasswordIcon.es.js';
import '../../Icons/icons/InformationCircleIcon.es.js';
import '../../Icons/icons/ListViewIcon.es.js';
import '../../Icons/icons/LockFilledIcon.es.js';
import '../../Icons/icons/LockOutlineIcon.es.js';
import '../../Icons/icons/LongArrowIcon.es.js';
import '../../Icons/icons/LoungeChairIcon.es.js';
import '../../Icons/icons/MagicIcon.es.js';
import '../../Icons/icons/MattressIcon.es.js';
import '../../Icons/icons/MenuIcon.es.js';
import '../../Icons/icons/MinibarIcon.es.js';
import '../../Icons/icons/MinusCircleIcon.es.js';
import '../../Icons/icons/MinusIcon.es.js';
import '../../Icons/icons/MlifeIcon.es.js';
import '../../Icons/icons/PanoramicViewIcon.es.js';
import '../../Icons/icons/PasswordXIcon.es.js';
import '../../Icons/icons/PhoneIcon.es.js';
import '../../Icons/icons/PlusCircleIcon.es.js';
import '../../Icons/icons/PlusIcon.es.js';
import '../../Icons/icons/PoolIcon.es.js';
import '../../Icons/icons/ProfileIcon.es.js';
import '../../Icons/icons/RefreshIcon.es.js';
import '../../Icons/icons/SafeIcon.es.js';
import '../../Icons/icons/SearchIcon.es.js';
import '../../Icons/icons/ShowPasswordIcon.es.js';
import '../../Icons/icons/ShowerIcon.es.js';
import '../../Icons/icons/SortIcon.es.js';
import '../../Icons/icons/SpaRocksIcon.es.js';
import '../../Icons/icons/SpecialEventsIcon.es.js';
import '../../Icons/icons/Spinner.es.js';
import '../../Icons/icons/SportsIcon.es.js';
import '../../Icons/icons/SpotCalendarIcon.es.js';
import '../../Icons/icons/StripViewIcon.es.js';
import '../../Icons/icons/TvIcon.es.js';
import '../../Icons/icons/UmbrellaIcon.es.js';
import '../../Icons/icons/WarningCircleIcon.es.js';
import '../../Icons/icons/WarningTriangleFilledIcon.es.js';
import '../../Icons/icons/WarningTriangleIcon.es.js';
import '../../Icons/icons/WiFiIcon.es.js';
import '../../Icons/icons/BestRateIcon.es.js';
import '../../Icons/icons/FiveDiamondAwardIcon.es.js';
import '../../Icons/icons/ForbesTravelGuideIcon.es.js';
import '../../Icons/icons/AriaStackedIcon.es.js';
import '../../Icons/icons/BeauRivageIcon.es.js';
import '../../Icons/icons/BellagioIcon.es.js';
import '../../Icons/icons/BellagioInternationalIcon.es.js';
import '../../Icons/icons/BorgataIcon.es.js';
import '../../Icons/icons/CircusCircusIcon.es.js';
import '../../Icons/icons/DelanoIcon.es.js';
import '../../Icons/icons/ExcaliburIcon.es.js';
import '../../Icons/icons/GoldStrikeIcon.es.js';
import '../../Icons/icons/LuxorIcon.es.js';
import '../../Icons/icons/MandalyBayIcon.es.js';
import '../../Icons/icons/MGMChinaIcon.es.js';
import '../../Icons/icons/MGMDiayutaiIcon.es.js';
import '../../Icons/icons/MGMGrandDetroitIcon.es.js';
import '../../Icons/icons/MGMGrandIcon.es.js';
import '../../Icons/icons/MGMGrandSanyaIcon.es.js';
import '../../Icons/icons/MGMMacauIcon.es.js';
import '../../Icons/icons/MGMNationalHarborIcon.es.js';
import '../../Icons/icons/MGMResortIcon.es.js';
import '../../Icons/icons/MGMSpringfieldIcon.es.js';
import '../../Icons/icons/MirageIcon.es.js';
import '../../Icons/icons/MyVegasIcon.es.js';
import '../../Icons/icons/NYNYIcon.es.js';
import '../../Icons/icons/ParkMGMIcon.es.js';
import '../../Icons/icons/SignatureIcon.es.js';
import '../../Icons/icons/VdaraIcon.es.js';
import '../../Icons/icons/FacebookIcon.es.js';
import '../../Icons/icons/TwitterIcon.es.js';
import '../../Icons/icons/YouTubeIcon.es.js';
import '../../Icons/icons/PinterestIcon.es.js';
import '../../Icons/icons/InstagramIcon.es.js';
import '../../Icons/icons/PlayMGMIcon.es.js';
import '../../Icons/icons/MGMGRIResortIcon.es.js';
import { StyledWrapper, StyledScrollUpIndicator, StyledList, StyledListInner, StyledScrollDownIndicator } from './SelectList.styles.es.js';
import { SelectListItem } from './SelectListItem.es.js';

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var SCROLL_INDICATOR_HEIGHT = 32;
var SelectList = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(SelectList, _React$PureComponent);

  var _super = _createSuper(SelectList);

  function SelectList() {
    var _this;

    _classCallCheck(this, SelectList);

    _this = _super.apply(this, arguments);
    _this._wrapperRef = /*#__PURE__*/React.createRef();
    _this.state = {
      showScrollUpIndicator: false,
      // It should be set to false as well,
      // but because Dropdown is transitioning max-height upon being open,
      // IntersectionObserver (at least on OSx Chrome) has problems with detecting if this element is visible
      // If we set it by default to true, the bottom arrow will be initially shown.
      // Then, it looks ok in every case, because:
      // - if there's no scroll (all elements are visible), then IntersectionObserver will actually trigger the event,
      //   and `showScrollDownIndicator` will be switched to false
      // - if there's scroll, then SelectList will be initially shown being scrolled to top, so let's show the
      //   bottom scroll indicator by default then.
      showScrollDownIndicator: _this.props.options.length > 7
    };

    _this.handleItemClick = function (option) {
      _this.props.onOptionClick(option);
    };

    _this.handleTopIntersectionChange = function (_ref) {
      var isIntersecting = _ref.isIntersecting;

      _this.setState({
        showScrollUpIndicator: !isIntersecting
      });
    };

    _this.handleBottomIntersectionChange = function (_ref2) {
      var isIntersecting = _ref2.isIntersecting;

      _this.setState({
        showScrollDownIndicator: !isIntersecting
      });
    };

    return _this;
  }

  _createClass(SelectList, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var scrollParent = getScrollParent(this._wrapperRef.current);
      var scrollbarWidth = 0;

      if (scrollParent && scrollParent !== window && !scrollParent.window) {
        scrollbarWidth = scrollParent.offsetWidth - scrollParent.clientWidth;
      }

      this.setState({
        scrollbarWidth: scrollbarWidth
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var updateNotCausedByIndicators = prevState.showScrollDownIndicator === this.state.showScrollDownIndicator && prevState.showScrollUpIndicator === this.state.showScrollUpIndicator;

      if (updateNotCausedByIndicators) {
        this._scrollToActiveOptionIfNeeded();
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this._wrapperRef.current) {
        this._wrapperRef.current.focus();
      }
    }
  }, {
    key: "isOptionSelected",
    value: function isOptionSelected(option) {
      if (this.props.multiple) {
        var currentValue = this.props.value || [];
        return currentValue.indexOf(option.value) !== -1;
      }

      return this.props.value === option.value;
    }
  }, {
    key: "_scrollToActiveOptionIfNeeded",
    value: function _scrollToActiveOptionIfNeeded() {
      var _this$props = this.props,
          id = _this$props.id,
          activeOptionIndex = _this$props.activeOptionIndex,
          options = _this$props.options;

      if (activeOptionIndex === -1) {
        return;
      }

      var listEl = this._wrapperRef.current;

      if (!listEl) {
        return;
      }

      var scrollContainer = getScrollParent(listEl);

      if (!scrollContainer || scrollContainer.self) {
        return;
      }

      var listItemEl = scrollContainer.querySelector("#".concat(id, "__option").concat(activeOptionIndex));

      if (!listItemEl) {
        return;
      }

      if (scrollContainer.scrollHeight > scrollContainer.clientHeight) {
        var hasPreviousItems = activeOptionIndex > 0;
        var hasNextItems = activeOptionIndex + 1 < options.length;
        var scrollBottom = scrollContainer.clientHeight + scrollContainer.scrollTop;
        var itemBottom = listItemEl.offsetTop + listItemEl.offsetHeight + (hasNextItems ? SCROLL_INDICATOR_HEIGHT : 0);
        var scrollTop = scrollContainer.scrollTop;
        var itemTop = listItemEl.offsetTop + (hasPreviousItems ? -SCROLL_INDICATOR_HEIGHT : 0);

        if (itemBottom > scrollBottom) {
          scrollContainer.scrollTop = itemBottom - scrollContainer.clientHeight;
        } else if (itemTop < scrollTop) {
          scrollContainer.scrollTop = itemTop;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          ariaLabelledBy = _this$props2['aria-labelledby'],
          multiple = _this$props2.multiple,
          options = _this$props2.options,
          activeOptionIndex = _this$props2.activeOptionIndex,
          onKeyDown = _this$props2.onKeyDown;
      var _this$state = this.state,
          showScrollUpIndicator = _this$state.showScrollUpIndicator,
          showScrollDownIndicator = _this$state.showScrollDownIndicator,
          scrollbarWidth = _this$state.scrollbarWidth;
      return /*#__PURE__*/React.createElement(StyledWrapper, {
        id: id,
        ref: this._wrapperRef,
        role: "listbox",
        tabIndex: 0,
        "aria-labelledby": ariaLabelledBy,
        "aria-multiselectable": multiple,
        "aria-activedescendant": "".concat(id, "__option").concat(activeOptionIndex),
        onKeyDown: onKeyDown,
        "data-testid": SelectList.displayName
      }, /*#__PURE__*/React.createElement(DivWithIntersectionObserver, {
        style: {
          width: '100%',
          height: 1
        },
        onChange: this.handleTopIntersectionChange
      }), /*#__PURE__*/React.createElement(StyledScrollUpIndicator, {
        visible: showScrollUpIndicator,
        style: {
          right: scrollbarWidth
        }
      }, /*#__PURE__*/React.createElement(DropdownArrowIcon, null)), /*#__PURE__*/React.createElement(StyledList, null, /*#__PURE__*/React.createElement(StyledListInner, null, options.map(function (option, index) {
        return /*#__PURE__*/React.createElement(SelectListItem, {
          key: option.key || option.value,
          id: "".concat(id, "__option").concat(index),
          active: _this2.isOptionSelected(option),
          selected: activeOptionIndex === index,
          label: option.styledLabel || option.label || option.value,
          // eslint-disable-next-line react/jsx-no-bind
          onClick: _this2.handleItemClick.bind(_this2, option)
        });
      }))), /*#__PURE__*/React.createElement(StyledScrollDownIndicator, {
        visible: showScrollDownIndicator,
        style: {
          right: scrollbarWidth
        }
      }, /*#__PURE__*/React.createElement(DropdownArrowIcon, null)), /*#__PURE__*/React.createElement(DivWithIntersectionObserver, {
        style: {
          width: '100%',
          height: 1
        },
        onChange: this.handleBottomIntersectionChange
      }));
    }
  }]);

  return SelectList;
}(React.PureComponent);
SelectList.displayName = 'SelectList';

export { SelectList };
